/**
 * 诉讼台账：服务端回包与本地补丁的合并工具。
 *
 * 说明：原文件为未提交的在途改动，清理时被误删；此处内容从构建产物
 * （dist/web/assets/app.js，2026-10-19 16:05 构建）反解恢复。
 * 变量名与类型标注为反解产物，逻辑与产物一致，请复核后再提交。
 */

export function mergeLitigationCaseResponse(current: any, response: any, submitted: any, pending: any = {}) {
  if (current.id !== response.id) throw new Error("服务器返回的案件编号不一致，已停止更新");
  const keys2 = new Set(Object.keys(submitted).filter((key) => !key.startsWith("_")));
  for (const key of ["internalNo", "organizationUnit", "updatedAt", "unfilledFields"]) keys2.add(key);
  if (keys2.has("courtNumbers")) {
    keys2.add("courtNo");
    keys2.add("instance");
  }
  if (keys2.has("venues")) keys2.add("venue");
  if (keys2.has("disputeType") || keys2.has("instance")) {
    keys2.add("instance");
    keys2.add("courtNumbers");
    keys2.add("venues");
  }
  if (keys2.has("stageName") || keys2.has("closed")) {
    keys2.add("nodes");
    keys2.add("closed");
    keys2.add("litigationClosedAt");
  }
  for (const key of ["id", "rowOrder", "participantOrder", "createdAt", "ownerUserId"]) keys2.delete(key);
  const accepted = Object.fromEntries([...keys2].filter((key) => Object.hasOwn(response, key)).map((key) => [key, response[key]]));
  return { ...current, ...accepted, ...pending, id: current.id, rowOrder: current.rowOrder, participantOrder: current.participantOrder };
}
export function remainingLitigationPatch(pending: any, submitted: any) {
  return Object.fromEntries(Object.entries(pending).filter(([key, value]) => !Object.hasOwn(submitted, key) || JSON.stringify(value) !== JSON.stringify(submitted[key])));
}
